module.exports = ["vừa rồi","%s giây trước","%s phút trước","%s giờ trước","%s ngày trước","%s tuần trước","%s tháng trước","%s năm trước"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/vi-VN.json
// module id = cjyA
// module chunks = 1